export default function PastTense() {
  return (
    <table className="table_sticky">
      <tbody>
        <tr>
          <th>
            <em>infinitive</em>
          </th>
          <td> dělati </td>
          <td> nesti </td>
          <td> hvaliti </td>
        </tr>
        <tr>
          <th>
            <em>infinitive stem</em>
          </th>
          <td>
            <b>děla-</b>
          </td>
          <td>
            <b>nes-</b>
          </td>
          <td>
            <b>hvali-</b>
          </td>
        </tr>
        <tr>
          <th> ja </th>
          <td> jesm dělal(a)</td>
          <td> jesm nesl(a)</td>
          <td> jesm hvalil(a) </td>
        </tr>
        <tr>
          <th> ty </th>
          <td> jesi dělal(a)</td>
          <td> jesi nesl(a)</td>
          <td> jesi hvalil(a) </td>
        </tr>
        <tr>
          <th>
            on <br /> ona <br /> ono
          </th>
          <td>
            dělal <br /> dělala <br /> dělalo
          </td>
          <td>
            nesl <br /> nesla <br /> neslo
          </td>
          <td>
            hvalil <br /> hvalila <br /> hvalilo
          </td>
        </tr>
        <tr>
          <th> my </th>
          <td> jesmo dělali</td>
          <td> jesmo nesli</td>
          <td> jesmo hvalili </td>
        </tr>
        <tr>
          <th> vy </th>
          <td> jeste dělali</td>
          <td> jeste nesli</td>
          <td> jeste hvalili </td>
        </tr>
        <tr>
          <th> oni/one </th>
          <td> dělali </td>
          <td> nesli </td>
          <td> hvalili </td>
        </tr>
      </tbody>
    </table>
  )
}
